import React from 'react';
import { useNetwork } from './NetworkGate';

export default function OfflineBanner() {
  const { online } = useNetwork();
  if (online) return null;
  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 100,
      background: '#fef3c7', color: '#92400e',
      padding: '8px 16px', fontSize: 14, textAlign: 'center',
      borderBottom: '1px solid #f59e0b',
    }}>
      You're offline. Only downloaded tickets are available.
    </div>
  );
}
